module.exports = __webpack_public_path__ + "static/img/ent-detail-74.f390a0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-74.jpg
// module id = P2qU
// module chunks = 52